export const GoodsDescription = () => {}
